module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ui column stackable grid"
  }, [_c('div', {
    staticClass: "ui divider sixteen wide column"
  }), _vm._v(" "), _c('header', {
    staticClass: "ui column sixteen wide heading"
  }, [_c('h1', {
    staticClass: "catagory-heading"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "ten wide column"
  }, [_vm._t("description")], 2), _vm._v(" "), _c('section', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "examples"
  }, [_vm._t("examples")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0a9d4753"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vars/DisplaySection.vue
// module id = 1441
// module chunks = 1